module.exports = __webpack_public_path__ + "img/logo.5f23b90a.png";